import { Button, Grid, Theme, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { get as _get } from 'lodash';
import { useLocation } from 'react-router-dom';
import { IconStateType } from '../../../types/type';
import { getPrettyClaimNumber } from '../../../utils/Utilities';
import ConfirmationHeader from '../../shared/ConfirmationHeader/ConfirmationHeader';
export default function ThirdPartyConfirmation() {
  const theme: Theme = useTheme();
  const { state } = useLocation();
  const headerContent = 'Your claim has been submitted.';
  const subHeaderContent = 'Claim #: ' + getPrettyClaimNumber(_get(state, 'claimNumber', ''));

  function goToWebsite() {
    // No-op function - placeholder for future implementation
  }

  const introContent = (
    <Grid container>
      <Grid item xs={12}>
        <Typography sx={{ marginTop: '20px' }} variant="body1">
          You will receive further communication on your claim as it progresses. Until that time, take reasonable steps
          to secure your vehicle/property to help prevent further damage. Please reach out with any questions you may
          have.
        </Typography>
      </Grid>
    </Grid>
  );

  /* If there are eligible services, the total number of stages will be more than 2 (Report and Complete are in the stages collection by default) */
  const content = (
    <>
      <Grid
        container
        sx={{
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
          margin: '0 auto',
        }}
      >
        <Grid item xs={12}>
          <ConfirmationHeader
            headerContent={headerContent}
            subHeaderContent={subHeaderContent}
            state={IconStateType.SUCCESS_STATE}
          ></ConfirmationHeader>
        </Grid>

        <Grid item xs={12}>
          <Typography
            sx={{
              ...theme.custom.styles.serviceConfirmationHeader,
              marginTop: '0rem',
            }}
          >
            Next Steps
          </Typography>
        </Grid>
        {introContent}
      </Grid>

      <Grid
        container
        sx={{
          marginTop: '3em',
          marginLeft: '0 auto',
          marginRight: '0 auto',
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
        }}
      >
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Button
              sx={{
                ...theme.custom.styles.ctaNextButton,
                '&.MuiButtonBase-root:hover': {
                  bgcolor: theme.custom.colors.primaryButtonHoverColor,
                },
              }}
              onClick={goToWebsite}
            >
              Go to Amfam.com
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
  return <Box sx={{ width: '100%' }}>{content}</Box>;
}
